import React, { useState, useEffect } from 'react';
import { Box, Typography, Collapse, TextField, Autocomplete, Chip } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import RollFilmIcon from '@mui/icons-material/CameraRoll';
import { predefinedShots } from '../services/shotService';

const ShotListSection = ({ missionData, setMissionData, setIsDirty, handleFieldChange }) => {
    const [isShotlistExpanded, setShotlistExpanded] = useState(true);

    useEffect(() => {
        setShotlistExpanded(!missionData?.completedAt);
    }, [missionData]);

    return (
        <Box
            sx={{
                backgroundColor: '#ffffff',
                border: '1px solid #dcdcdc',
                borderRadius: '8px',
                padding: '16px',
                marginBottom: '16px',
                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    marginBottom: isShotlistExpanded ? '0px' : '0px',
                }}
                onClick={() => setShotlistExpanded(!isShotlistExpanded)}
            >
                <RollFilmIcon sx={{ color: '#42a5f5', marginRight: '8px' }} />
                <Typography variant="h6" sx={{ flexGrow: 1 }}>
                    Shot List
                </Typography>
                {isShotlistExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </Box>
            <Collapse in={isShotlistExpanded}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '16px',
                        marginTop: '16px',
                    }}
                >
                    {/* Predefined Shot List with Grouping */}
                    <Autocomplete
                        multiple
                        id="shot-list-select"
                        options={predefinedShots}
                        groupBy={(option) => option.category} // Group by category
                        getOptionLabel={(option) => option.label}
                        value={missionData?.predefinedShots || []}
                        onChange={(event, value) => {
                            // Filter out duplicate labels
                            const uniqueValues = Array.from(new Set(value.map((item) => item.label)))
                                .map((label) => value.find((item) => item.label === label));

                            handleFieldChange({
                                target: {
                                    name: 'predefinedShots',
                                    value: uniqueValues,
                                },
                            });
                        }}
                        disableCloseOnSelect
                        renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                                <Chip
                                    variant="outlined"
                                    label={option.label}
                                    {...getTagProps({ index })}
                                    key={option.label}
                                />
                            ))
                        }
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Predefined Shots"
                                placeholder="Select shots"
                                helperText="Choose from predefined shots and/or add your own below."
                                fullWidth
                            />
                        )}
                        fullWidth
                        sx={{ marginBottom: '16px' }}
                    />

                    {/* Custom Shot List Input */}
                    <TextField
                        id="custom-shot-list"
                        name="customShotList"
                        label="Custom Shots"
                        multiline
                        minRows={3}
                        value={missionData?.customShotList || ''}
                        onChange={handleFieldChange}
                        fullWidth
                        slotProps={{ input: { maxLength: 1000 } }}
                        helperText={
                            missionData?.customShotList
                                ? `${missionData.customShotList.length}/1000 characters used. Add any custom shots required for this mission.`
                                : 'Add any custom shots required for this mission.'
                        }
                    />
                </Box>
            </Collapse>
        </Box>
    );
};

export default ShotListSection;